import React from "react";
import { ArchiveSvg } from "assets/icons/ArchiveSvg";

const EmptyArchive = ({ emptyText }) => {
  return (
    <div className="text-center d-flex flex-column align-items-center my-5">
      <ArchiveSvg />
      <small className="my-2">{emptyText}</small>
    </div>
  );
};

export default EmptyArchive;
